/* Dawn GPT: sticky mobile purchase control; uses the existing Shopify product form. */
(function(){
  function init(){
    if(!window.matchMedia('(max-width: 749px)').matches) return;
    var section=document.querySelector('[id^="MainProduct-"]');
    if(!section) return;
    var original=section.querySelector('product-form button[name="add"]');
    var form=original&&original.closest('product-form');
    if(!original||!form||document.querySelector('.gpt-sticky-buy')) return;
    var bar=document.createElement('div');bar.className='gpt-sticky-buy';bar.setAttribute('aria-label','Quick purchase');
    var text=document.createElement('span');text.className='gpt-sticky-buy__text';text.textContent='Ready to order?';
    var button=document.createElement('button');button.type='button';button.className='gpt-sticky-buy__button';
    bar.appendChild(text);bar.appendChild(button);document.body.appendChild(bar);
    function sync(){
      var label=original.querySelector('span');
      button.textContent=(label&&label.textContent.trim())||'Add to cart';
      button.disabled=original.disabled;
      var rect=original.getBoundingClientRect();
      var visible=rect.top<window.innerHeight&&rect.bottom>0;
      var show=!visible&&rect.top<0&&window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-visible',show);document.body.classList.toggle('gpt-sticky-buy-active',show);
    }
    button.addEventListener('click',function(){
      if(button.disabled)return;
      var selected=form.querySelector('form input[name="id"]');
      if(!selected||!selected.value){original.scrollIntoView({behavior:'smooth',block:'center'});return}
      original.click();
    });
    var observer=new MutationObserver(sync);observer.observe(original,{attributes:true,attributeFilter:['disabled']});
    var label=original.querySelector('span');if(label)observer.observe(label,{childList:true,subtree:true,characterData:true});
    window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
